export enum Message {
  Success = "Success",
  Error = "Error",
  Warning = "Warning",
  Info = "Info",
  ErrorMessage = "An error occurred. Please try again later.",
  ErrorMessageLocationAccess = "Location access blocked. Please enable to continue",
  ErrorMessageLocationUnavailable = "We couldn't determine your location. Check your connection and try again.",
  ErrorMessageCountryAccess = "Access blocked. Application is not available in your country.",
  ErrorMessageDeviceId = "Error in getting deviceId. Please try again later.",
  ErrorMessageDeviceType = "Error in getting device type. Please try again later.",
  ErrorMessageDeviceIpAddress = "Error in getting device IP address. Please try again later.",
  ErrorMessageDeviceGeoCoordinates = "Error in getting device geo coordinates. Please try again later.",
  ErrorMessageDeviceHashId = "Error in getting device hash id. Please try again later.",
  ErrorMessageDevicermation = "Error in getting device information. Please try again later.",
  ErrorMessageGetToken = "Error in getting token. Please try again later.",
  ErrorMessageLinksDisallowed = "Links are not allowed. Please remove any links and try again.",
  ErrorMessageSession = "Error in starting the session. Please try again later.",
  ErrorMessageTokenDate = "Error in getting token date. Please try again later.",
  ErrorMessageGetKeys = "Error in getting keys. Please try again later.",
  LogoutMessage = "You have been logged out.",
  LogoutSuccess = "You have been logged out successfully.",
  SessionExpiredInactivity = "Your session has expired due to inactivity. Please sign in again.",
  InvalidCredentials = "Invalid username or password.",
  EncryptedTextCopiedToClipboard = "Encrypted text copied to clipboard.",
  DecryptedTextCopiedToClipboard = "Decrypted text copied to clipboard.",
  EncryptedTextPastedFromClipboard = "Encrypted text pasted from clipboard.",
  DecryptedTextPastedFromClipboard = "Decrypted text pasted from clipboard.",
  EncryptedDataCleared = "Encrypted data cleared.",
  DecryptedDataCleared = "Decrypted data cleared.",
  Encryption = "encryption",
  ErrorMessageLoginFailed = "Incorrect email/password",
  ErrorMessageIncorrectLoginCredentials = "Incorrect email or password. Please verify and try again.",
  PinResentSuccess = "Pin resent successfully.",
  Forbidden = "Your Session has been expired",
  NotAuthorized = "Not Authorized",
  ErrorMessageNoConnection = "It looks like you’re not connected to the internet. Check Wi-Fi or data settings and try again.",
  NoRetailerStoreSelected = "No Retailer Found, Please Check Device Location Settings are Enabled.",
  NoRetailerAvailableMessage = "No Retailer Found, If location services are enabled and you are not seeing your store/retailer, please try updating your geo data. Turn off all data/network connections, enable airplane mode, then restart the device. After restarting, re-enable data and attempt to log back in.",
  DuplicateIMEIError = "Duplicate IMEI was submitted, please retype or rescan the IMEI and reattempt submission.",
  ErrorMessageShippingAddressUspsRequired = "Your shipping address must be a USPS validated address and cannot be a PO BOX.",
  ErrorMessageBillingAddressMatchesService = "The billing address cannot match the service address.",
  CreditCheckFailedErrorMessageTitle = "Credit Check Failed",
  VoiceFlowInternetRequiredErrorMessage = "Please select an Internet plan before choosing a voice product. Voice services require an active Internet plan to work.",
  LaunchInContextProcessErrorMessage = "Unable to process launch in context.",
  LaunchInContextConflictProcessErrorMessage = "Launch is already used. Please contact support for assistance.",
}

export const serviceDownMessages: MessageModel[] = [
  {
    severity: 'warn',
    detail: 'Provider services down. Only Lead Data will be collected. For live updates and help, click to scan the QR code below.',
  }
]

export const wirelessSetupErrorSelectionMessages: MessageModel[] = [
  {
    severity: 'warn',
    detail: 'Please make a selection before proceeding',
  }
]

export const expressSchedulingMessages: MessageModel[] = [
  {
    severity: 'success',
    detail: 'The earliest installation times have been pre-selected below. To continue with these times, tap the Submit button.',
  }
]

export const fdeIncompleteMessage: MessageModel[] = [
  {
    severity: 'error',
    detail: 'Wireless ID Authentication Incomplete. Please wait for the Customer to complete the authentication process.',
  }
]

export const fdeCancelledMessage: MessageModel[] = [
  {
    severity: 'error',
    detail: 'AT&T is unable to proceed with this order. Do not call for review.',
  }
]

export const fdeCompleteMessage: MessageModel[] = [
  {
    severity: 'success',
    detail: 'Wireless ID Authentication Completed!',
  }
]

export const channelsErrorMessage: MessageModel[] = [
  {
    severity: 'error',
    Title: 'Please check all mandatory fields before proceeding.',
    detail: 'All required fields must be completed before continuing. These fields are highlighted for your attention.'
  }
]

export const landlordErrorMessage: MessageModel[] = [
  {
    severity: 'error',
    Title: 'Landlord Permission Required',
    detail: 'Please make a selection before proceeding.'
  }
]

export interface MessageModel {
  severity: 'success' | 'error' | 'warn' | 'info';
  Title?: string;
  detail: string;
}
